import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import 'vue-awesome/icons';
import SmoothScroll from 'vue-smoothscroll';
import Icon from 'vue-awesome/components/Icon';
import App from './App';
import store from './store';
import router from './router';
import i18n from './locales';
import { EventBus } from './utils/event-bus';

Vue.config.productionTip = false;

Raven
  .config('https://621f01ca01b44af6bc7bd349a6fc786b@sentry.io/96476')
  .addPlugin(RavenVue, Vue)
  .install();

Vue.component('icon', Icon);
Vue.use(SmoothScroll);

Object.defineProperties(Vue.prototype, {
  $bus: {
    get() {
      return EventBus;
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  template: '<App/>',
  components: { App, Icon },
});



// WEBPACK FOOTER //
// ./src/main.js